module.exports = __webpack_public_path__ + "static/media/settings-icon.f0b5ef85.svg";